var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row",attrs:{"id":"info"}},[_c('navbar'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"overflow-scroll",staticStyle:{"max-width":"95vw"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }